import { Crosshair, ShieldCheck } from "lucide-react";

/**
 * Product definitions with display names and icons.
 */
export const PRODUCTS = {
  redteam: {
    label: "Red Team",
    displayName: "Red Team",
    icon: Crosshair,
  },
  security: {
    label: "Security",
    displayName: "Security Platform",
    icon: ShieldCheck,
  },
} as const;

/**
 * Type representing a product key.
 */
export type ProductKey = keyof typeof PRODUCTS;

/**
 * Valid product keys for runtime validation.
 */
export const VALID_PRODUCT_KEYS = Object.keys(PRODUCTS) as ProductKey[];
